/**
 * Email AI — Accept/Cancel + parent button spinner.
 *
 * Accept/Cancel: copies AI suggestion text into the body textarea.
 * Works for both reply (email-ai-suggestion-wrapper) and compose (compose-ai-suggestion-wrapper).
 * A wrapper not in the map (the acqs composers, whose form ids vary) names its textarea in
 * `data-ai-textarea`.  A card's `.ai-suggestion-subject` (acqs Suggest reply) fills the
 * subject input of the textarea's form.  A new AI request, or a reset of the form holding the
 * wrapper, drops the card.
 * Parent spinner: loading.js targets the hx-post element (dropdown item),
 *   but we need the spinner on the parent Improve/Write button instead.
 * Textarea disable uses hx-disabled-elt in the template — no JS needed.
 */

(function () {

    var WRAPPER_TEXTAREA_MAP = {
        'email-ai-suggestion-wrapper': '#email-reply-form textarea[name="body"]',
        'compose-ai-suggestion-wrapper': '#compose-form textarea[name="body"]',
    };

    // Accept / Cancel
    document.body.addEventListener('click', function (e) {
        var accept = e.target.closest('.js-ai-accept');
        var cancel = e.target.closest('.js-ai-cancel');
        if (!accept && !cancel) return;

        var card = (accept || cancel).closest('#email-ai-suggestion');

        if (accept && card) {
            var suggestion = card.querySelector('.ai-suggestion-text');
            var wrapper = card.parentElement;
            var textareaSelector = wrapper && (WRAPPER_TEXTAREA_MAP[wrapper.id] || wrapper.dataset.aiTextarea);
            var textarea = textareaSelector && document.querySelector(textareaSelector);
            if (suggestion && textarea) {
                textarea.value = suggestion.textContent;
                textarea.dispatchEvent(new Event('input', { bubbles: true }));
                var suggestedSubject = card.querySelector('.ai-suggestion-subject');
                var subject = suggestedSubject && textarea.form && textarea.form.querySelector('input[name="subject"]');
                if (subject) subject.value = suggestedSubject.textContent;
            }
        }

        if (card) {
            var w = card.parentElement;
            if (w) w.innerHTML = '';
        }
    });

    // A form reset (the acqs SMS send) drops a card inside the form.
    document.body.addEventListener('reset', function (e) {
        if (e.target.tagName !== 'FORM') return;
        e.target.querySelectorAll('[id$="-ai-suggestion-wrapper"]').forEach(function (w) { w.innerHTML = ''; });
    });

    // Spinner on parent Improve/Write button during AI request
    var _activeBtn = null;

    function isAiRequest(evt) {
        var target = evt.detail.elt.getAttribute('hx-target') || '';
        return target.indexOf('-suggestion-wrapper') !== -1;
    }

    document.body.addEventListener('htmx:beforeRequest', function (evt) {
        if (!isAiRequest(evt)) return;
        // Drop the previous card, so a failed request cannot leave an older suggestion to Accept.
        var wrapper = document.querySelector(evt.detail.elt.getAttribute('hx-target'));
        if (wrapper) wrapper.innerHTML = '';
        var dropdown = evt.detail.elt.closest('.dropdown');
        _activeBtn = dropdown ? dropdown.querySelector('[data-dropdown]') : null;
        if (!_activeBtn) return;
        var icon = _activeBtn.querySelector('i');
        if (icon) {
            icon.setAttribute('data-original-class', icon.className);
            icon.className = (icon.classList.contains('chip-icon') ? 'chip-icon ' : '') + 'fa-solid fa-spinner fa-spin';
        }
    });

    document.body.addEventListener('htmx:afterRequest', function (evt) {
        if (!isAiRequest(evt)) return;
        if (_activeBtn) {
            var icon = _activeBtn.querySelector('i');
            if (icon && icon.hasAttribute('data-original-class')) {
                icon.className = icon.getAttribute('data-original-class');
                icon.removeAttribute('data-original-class');
            }
            _activeBtn = null;
        }
    });

})();
